import React from "react";
import { observer } from "mobx-react";
import { Route, Routes } from "react-router-dom";
import $projects from "@/core/projects/store";
import $translations from "@/core/translations/store";
import $locales from "@/core/locales/store";
import Box from "@mui/material/Box";
import Header from "@/components/Header";
import Projects from "@/components/Projects";
import TranslateEditor from "@/components/TranslateEditor";
import CreateTranslateMaster from "@/components/CreateTranslateMaster";
import Locales from "@/components/Locales";
import LocalePage from "@/components/Locales/Page";
import LocaleForm from "@/components/Locales/Form";
import ApiKeys from "@/components/ApiKeys";
import McpCard from "@/components/McpCard";

function App() {
  React.useEffect(() => {
    $locales.fetchData();
    $projects.fetchData();
  }, []);

  React.useEffect(() => {
    $translations.fetchData();
  }, [$projects.getActive]);

  React.useEffect(() => {
    const listener = (event) => {
      if (!$translations.changed) return;
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", listener);
    return () => window.removeEventListener("beforeunload", listener);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
    >
      <Header />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
        }}
      >
        <Routes>
          <Route path="/master" element={<CreateTranslateMaster />} />
          <Route path="/project/:projectId/*" element={<TranslateEditor />} />
          <Route path="/locales" element={<LocalePage />} />
          <Route path="/api-keys" element={<ApiKeys />} />
          <Route
            path="/add-locale"
            element={
              <Box sx={{ maxWidth: 800 }}>
                <LocaleForm />
              </Box>
            }
          />
          <Route
            path="/"
            exact
            element={
              <Box sx={{ maxWidth: 800 }}>
                <McpCard />
                <Locales />
                <Projects />
              </Box>
            }
          />
        </Routes>
      </Box>
    </Box>
  );
}

export default observer(App);
